import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedConstants, SharedCSSPropertyName } from '@app/eds';

@Component({
  selector: 'app-icon[name][size]',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent {
  //Icon Input Props loke name, color, size.
  @Input() name: string = SharedConstants.EMPTY_STRING;
  @Input() color!: string;
  @Input() size!: string;
  @Input() public iconClassNames!: string[];

  // This Props will trigger event for icon component.
  @Output() iconClicked = new EventEmitter();

  /**
   * This method is triggered when user clicks on icon.
   */
  onClick = (): void => this.iconClicked.emit();

  /**
   * This method return style for icon.
   *
   * @returns object
   */
  getStyles = () => {
    const styleObject: { [key: string]: string } = {};

    this.size && (styleObject[SharedCSSPropertyName.FONT_SIZE] = this.size);
    this.color && (styleObject[SharedCSSPropertyName.COLOR] = this.color);

    return styleObject;
  };
}
